import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class ViewReportButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      iclass: ''
    };
  }

  handleClick(blobProvider, filename) {
    if (this.state.disabled) {
      return;
    }

    this.setState({
      disabled: true, iclass: 'spinner'
    }, () => {
      blobProvider()
        .then(data => {
          filename = data.fileName || filename;
          const byteCharacters = atob(data.bytes);
          const byteNumbers = new Array(byteCharacters);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: data.mimeType });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // TODO: Pass in the name and get the correct file extension.
            window.navigator.msSaveOrOpenBlob(blob, filename);
          }
          else {
            //Build a URL from the file
            const fileURL = URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = fileURL;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(fileURL);
            }, 0);
          }
        })
        .finally(() => {
          this.setState({
            disabled: false, iclass: ''
          });
        });
    });
  }

  render() {
    return (
      <Button className="k-button" title="View document button"
        onClick={() => this.handleClick(this.props.getData, this.props.defaultFilename || 'report.pdf')}
        disabled={this.state.buttonDisabled}>
          {this.state.disabled ? <FontAwesomeIcon style={{ height: "20px", width: "28.766" }} icon={this.state.iclass} spin /> : 'Print'}
      </Button>);
  }
}